import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { CoreEffects } from 'angular-engine/engine/state/effect/core.effects';
import { StaticContainer } from 'angular-shared-features/feature/shared-component/static-container.component';

@Component({
  selector: 'embed-video-container',
  templateUrl: './embed.video-container.template.html',
  styleUrls: ['./embed.video-container.style.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmbedVideoContainer extends StaticContainer {

}



// WEBPACK FOOTER //
// ./src/angular-framework-client-components/containers/video-container/embed/embed.video-container.component.ts